module.exports = __webpack_public_path__ + "img/handsome-guy.9bd28485.png";